export default import.meta.ROLLUP_FILE_URL_fXF$XjNon4ADjy3AbQzWAQ